import React from 'react'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useDataValue, useDataChange } from 'Simple/Data.js'

import View from './view.js'

function useOnClickNext(props) {
  let current = useDataValue({
    context: 'current_row',
    path: 'item',
    viewPath: props.viewPath,
  })

  let order = useDataValue({
    context: 'selected',
    path: 'ordered_rows',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'current_row',
    path: 'item',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let nextPos = order.indexOf(current.id) + 1
    change({ index: nextPos, id: order[nextPos] })
  }
}

export function useOnClickPrev(props) {
  let current = useDataValue({
    context: 'current_row',
    path: 'item',
    viewPath: props.viewPath,
  })

  let order = useDataValue({
    context: 'selected',
    path: 'ordered_rows',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'current_row',
    path: 'item',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let nextPos = order.indexOf(current.id) - 1
    change({ index: nextPos, id: order[nextPos] })
  }
}

export default function Logic(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let handleOnClickNextAction = useOnClickNext(props)
  let handleOnClickPrevAction = useOnClickPrev(props)

  let leads = useDataValue({
    viewPath: props.viewPath,
    context: 'marketing_analytics',
    path: 'leads',
  })

  let current_index = useDataValue({
    viewPath: props.viewPath,
    context: 'current_row',
    path: 'item.index',
  })

  return (
    <View
      {...props}
      handleClose={() => setFlowTo(normalizePath(props.viewPath, '../No'))}
      onClickNextAction={handleOnClickNextAction}
      onClickPrevAction={handleOnClickPrevAction}
      nextActionDisabled={!(current_index + 1 !== leads.length)}
      prevActionDisabled={!current_index}
    />
  )
}
